import { Navigate } from "react-router-dom";
import { getMyAffiliateDashboard, useQuery } from "wasp/client/operations";
import useTranslation from "../client/hooks/useTranslation";
import { useIsDark } from "../client/components/ui/card-section-header";
import { Skeleton } from "../client/components/ui/skeleton";
import OverviewKpis from "./components/OverviewKpis";
import CommissionsSection from "./components/CommissionsSection";
import PayoutsSection from "./components/PayoutsSection";
import MyLinkCard from "./components/MyLinkCard";
import PayoutSettingsCard from "./components/PayoutSettingsCard";
import BrandingKitSection from "./components/BrandingKitSection";

export default function AffiliatePage() {
  const t = useTranslation();
  const isDark = useIsDark();
  const { data, isLoading, error } = useQuery(getMyAffiliateDashboard);

  // Garde client : pas de profil actif → retour dashboard (la garde serveur
  // renvoie 403 sur toutes les queries/actions de toute façon)
  if (error) {
    return <Navigate to="/dashboard" replace />;
  }

  if (isLoading || !data) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8 space-y-4">
        <Skeleton className="h-8 w-64" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {[0, 1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-28" />
          ))}
        </div>
        <Skeleton className="h-64" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-8 space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight font-display">
          {t.affiliate.pageTitle}
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          {t.affiliate.pageSubtitle}
        </p>
      </div>

      <OverviewKpis kpis={data.kpis} isDark={isDark} />

      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 items-start">
        <div className="xl:col-span-2 space-y-6">
          <CommissionsSection
            balances={data.balances}
            commissions={data.commissions}
            canRequestPayout={data.canRequestPayout}
            minPayoutAmount={data.minPayoutAmount}
            hasPayoutDetails={
              !!data.profile.payoutMethod && !!data.profile.payoutDetails
            }
            isDark={isDark}
          />
          <PayoutsSection payouts={data.payouts} isDark={isDark} />
        </div>
        <div className="space-y-6">
          <MyLinkCard profile={data.profile} isDark={isDark} />
          <PayoutSettingsCard profile={data.profile} isDark={isDark} />
        </div>
      </div>

      <BrandingKitSection isDark={isDark} />
    </div>
  );
}
